import { FeatureFlag } from '~/types/featureFlag';

import { i18n } from '~/utils';

/**
 * Internationalized descriptions of all feature flags.
 */
export const FEATURE_FLAG_DESCRIPTION = {
  [FeatureFlag.AgentChat]: i18n.t(($) => $.featureFlags.agentChat.description, {
    ns: 'admin-webapp',
  }),
  [FeatureFlag.AccessArchive]: i18n.t(
    ($) => $.featureFlags.accessArchive.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.BusinessPartnerSettings]: i18n.t(
    ($) => $.featureFlags.businessPartnerSettings.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.ClientPortal]: i18n.t(
    ($) => $.featureFlags.clientPortal.description,
    {
      ns: 'admin-webapp',
    },
  ),
  [FeatureFlag.ConcreteDiary]: i18n.t(
    ($) => $.featureFlags.concreteDiary.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.CreateDeliveryNote]: i18n.t(
    ($) => $.featureFlags.createDeliveryNote.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.CreateDemoDlns]: i18n.t(
    ($) => $.featureFlags.createDemoDlns.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.CustomerSubscription]: i18n.t(
    ($) => $.featureFlags.customerSubscription.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.DataSyncUi]: i18n.t(
    ($) => $.featureFlags.dataSyncUi.description,
    {
      ns: 'admin-webapp',
    },
  ),
  [FeatureFlag.DeactivatedCompanyAccount]: i18n.t(
    ($) => $.featureFlags.deactivatedCompanyAccount.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.DisableGps]: i18n.t(
    ($) => $.featureFlags.disableGps.description,
    {
      ns: 'admin-webapp',
    },
  ),
  [FeatureFlag.DisableInvoices]: i18n.t(
    ($) => $.featureFlags.disableInvoices.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.DlnListV2]: i18n.t(($) => $.featureFlags.dlnListV2.description, {
    ns: 'admin-webapp',
  }),
  [FeatureFlag.EnableFastScan]: i18n.t(
    ($) => $.featureFlags.enableFastScan.description,
    {
      ns: 'admin-webapp',
    },
  ),
  [FeatureFlag.EnableValidatedScan]: i18n.t(
    ($) => $.featureFlags.enableValidatedScan.description,
    {
      ns: 'admin-webapp',
    },
  ),
  [FeatureFlag.EsgAnalytics]: i18n.t(
    ($) => $.featureFlags.esgAnalytics.description,
    {
      ns: 'admin-webapp',
    },
  ),
  [FeatureFlag.EsgMaterialMatcher]: i18n.t(
    ($) => $.featureFlags.esgMaterialMatcher.description,
    {
      ns: 'admin-webapp',
    },
  ),
  [FeatureFlag.Flixbeton]: i18n.t(($) => $.featureFlags.flixbeton.description, {
    ns: 'admin-webapp',
  }),
  [FeatureFlag.InvoiceListV2]: i18n.t(
    ($) => $.featureFlags.invoiceListV2.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.LoadDlnsAmount]: i18n.t(
    ($) => $.featureFlags.loadDlnsAmount.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.ModuleCallOffs]: i18n.t(
    ($) => $.featureFlags.moduleCallOffs.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.ModuleContracts]: i18n.t(
    ($) => $.featureFlags.moduleContracts.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.ModuleInvoiceRestriction]: i18n.t(
    ($) => $.featureFlags.moduleInvoiceRestriction.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.NoPrivacyStatement]: i18n.t(
    ($) => $.featureFlags.noPrivacyStatement.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.PackageBasicRestriction]: i18n.t(
    ($) => $.featureFlags.packageBasicRestriction.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.PgDlnAnalytics]: i18n.t(
    ($) => $.featureFlags.pgDlnAnalytics.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.PgDlnAttachments]: i18n.t(
    ($) => $.featureFlags.pgDlnAttachments.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.PgDlnBulk]: i18n.t(($) => $.featureFlags.pgDlnBulk.description, {
    ns: 'admin-webapp',
  }),
  [FeatureFlag.PgDlnChains]: i18n.t(
    ($) => $.featureFlags.pgDlnChains.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.PgDlnDetail]: i18n.t(
    ($) => $.featureFlags.pgDlnDetail.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.PgDlnList]: i18n.t(($) => $.featureFlags.pgDlnList.description, {
    ns: 'admin-webapp',
  }),
  [FeatureFlag.PgDlnSearch]: i18n.t(
    ($) => $.featureFlags.pgDlnSearch.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.PgDlnTransformed]: i18n.t(
    ($) => $.featureFlags.pgDlnTransformed.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.PgDlnVadmin]: i18n.t(
    ($) => $.featureFlags.pgDlnVadmin.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.ProductAnalyticsTools]: i18n.t(
    ($) => $.featureFlags.productAnalyticsTools.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.ManageProductPrices]: i18n.t(
    ($) => $.featureFlags.manageProductPrices.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.ManualInvoiceCheckingPipeline]: i18n.t(
    ($) => $.featureFlags.manualInvoiceCheckingPipeline.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.ReleaseSyncedData]: i18n.t(
    ($) => $.featureFlags.releaseSyncedData.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.SentryGoogleAnalyticsDisabled]: i18n.t(
    ($) => $.featureFlags.sentryGoogleAnalyticsDisabled.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.ServiceNotes]: i18n.t(
    ($) => $.featureFlags.serviceNotes.description,
    {
      ns: 'admin-webapp',
    },
  ),
  [FeatureFlag.SupplierOverview]: i18n.t(
    ($) => $.featureFlags.supplierOverview.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.SupplierOverviewForceCsRouting]: i18n.t(
    ($) => $.featureFlags.supplierOverviewForceCsRouting.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.SupplierOverviewRequestSupplier]: i18n.t(
    ($) => $.featureFlags.supplierOverviewRequestSupplier.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.SuppliersKanban]: i18n.t(
    ($) => $.featureFlags.suppliersKanban.description,
    { ns: 'admin-webapp' },
  ),
  [FeatureFlag.UserInDlnHistory]: i18n.t(
    ($) => $.featureFlags.userInDlnHistory.description,
    { ns: 'admin-webapp' },
  ),
};
